import { render, staticRenderFns } from "./Headline.vue?vue&type=template&id=5c7afcdc&scoped=true"
var script = {}
import style0 from "./Headline.vue?vue&type=style&index=0&id=5c7afcdc&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7afcdc",
  null
  
)

export default component.exports